import { CircularProgress } from "@material-ui/core";
import styled from "styled-components";
import { mediaMax } from "components/designV2/breakpoints";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const SectionHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const SectionHeaderLeft = styled.div`
  display: inline-flex;
  align-items: baseline;
  gap: 10px;
`;

export const SectionTitle = styled.h3`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
  margin: 0;
`;

export const SectionMeta = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
  white-space: nowrap;
`;

export const DataCard = styled.div`
  position: relative;
  border-radius: 12px;
  background: ${ColorV2.White};
  padding: 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DataCardLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

export const LoadingSpinner = styled(CircularProgress).attrs({
  size: 28,
})`
  color: ${ColorV2.Blue1};
`;

export const KeyValueRow = styled.div`
  display: grid;
  grid-template-columns: minmax(90px, 1fr) minmax(120px, 1fr);
  align-items: center;
  gap: 12px;
`;

export const InlineFieldGroup = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;

export const InlineFieldLabel = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue3};
`;

export const TimePickerWrap = styled.span`
  display: inline-flex;
`;

export const KeyLabel = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue3};
`;

export const Value = styled.span`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
  text-align: right;
`;

export const ValueWithChip = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

export const OvertimeChip = styled.span`
  ${TypographyV2.s1};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 999px;
  min-height: 24px;
  padding: 4px 10px;
  color: ${ColorV2.NegativeRed};
  background: ${ColorV2.NegativeRedLight};
  white-space: nowrap;
`;

export const MutedValue = styled(Value)`
  color: ${ColorV2.Blue4};
`;

export const Divider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid ${ColorV2.Blue6};
  margin: 0;
`;

export const CommentCard = styled.div`
  border-radius: 12px;
  background: ${ColorV2.Blue6};
  padding: 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CommentTitle = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue1};
`;

export const CommentText = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue1};
`;

export const Footer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;

  & > button,
  & > div,
  & > div button {
    width: 100%;
    min-width: 0;
    white-space: nowrap;
  }

  ${mediaMax.tabletLarge} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  ${mediaMax.mobileLarge} {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const EditFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
`;

export const FeedbackBodyText = styled.p`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue1};
  margin: 0;
  text-align: center;
`;

export const StatusBannerLoadingWrap = styled.div`
  width: 100%;
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: ${ColorV2.White};
`;

export const CompactStatusBanner = styled.div<{
  $textColor: ColorV2;
  $backgroundColor: string;
}>`
  width: 100%;
  min-height: 52px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  background: ${(props) => props.$backgroundColor};
  color: ${(props) => props.$textColor};
`;

export const CompactStatusBannerLabel = styled.span`
  ${TypographyV2.b2};
  line-height: 1.2;
`;
